export const extractRoleType = (role) => {
  if (!role) return '';
  // Prendre tout ce qui est après le premier underscore
  const parts = role.split('_');
  return parts.length > 1 ? parts.slice(1).join('_') : role;
};
